<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'SubCategories',
          to: {
            name: 'SubCategories'
          }
        },
        {
          name: 'SubCategory Info',
          to: {
            name: 'SubCategoryInfo',
            params: {
              id: $route.params.id
            }
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'SubCategoryInfoEdit',
            params: {
              id: $route.params.id
            }
          }
        }
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯子分類</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>

    <!--  -->
    <SubCategoryEditCreate></SubCategoryEditCreate>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SubCategoryEditCreate from '@/views/C-2__SubCategory/c/SubCategoryEditCreate.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    SubCategoryEditCreate,
    Breadscrumbs,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('subcategory', ['subcategory']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getSubCategory(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('subcategory', {
      getSubCategory: 'findById',
      save: 'save',
      clear: 'clear',
    }),
    cancelHandler() {
      this.clear();
      this.$router.push({ name: 'SubCategories' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.save(this.subcategory).then(() => {
          this.clear();
          this.$router.push({ name: 'SubCategories' });
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>
